import formatNumber, { FormatNumberOptions } from './formatNumber'

export default function formatPercentage(pct: number, options?: FormatNumberOptions): string {
  return `${formatNumber(pct * 100, {
    ...options,
    showCommas: false,
  })}%`
}
